<div>
  <ivr-sub-menu #ivrSubMenuForm [isSubMenu]="true" [ivrmenu]="originIvrSubMenu" [excludeIvrMenuId]="excludeIvrMenuId" (valueChange)="updateSubMenuParam($event)"
    [shouldViewSubMenu]="true">
  </ivr-sub-menu>
</div>
